module.exports = __webpack_public_path__ + "static/media/AvantGardeBook.86d4debc.svg";